/**
 * Download Portal Configuration
 *
 * Validates all required environment variables at startup using Zod.
 * All values come from Doppler - no defaults for URLs or secrets.
 *
 * Philosophy:
 * - Fail fast: App crashes on startup if misconfigured
 * - No defaults for URLs or secrets - require them
 * - Optional only for feature flags or genuinely optional features
 *
 * Note: Download Portal uses Vite so env vars use `import.meta.env` with VITE_ prefix.
 */
import { z } from 'zod';

const envSchema = z.object({
  // ===== Core URLs (required) =====
  VITE_BACKEND_URL: z.string().url(),
});

// Validate on module load - app crashes early if misconfigured
const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('❌ Invalid environment configuration:', parsed.error.format());
  throw new Error(
    `Environment validation failed. Missing or invalid env vars: ${parsed.error.issues.map(i => i.path.join('.')).join(', ')}`
  );
}

/**
 * Validated environment configuration.
 * All values are type-safe and guaranteed to exist.
 */
export const config = parsed.data;
